import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  to_date() {
    this.element.value += '-01'
    console.log(this.element)
  }
}